export default __webpack_public_path__ + "static/media/take3.6fd8f262.JPG";